export default "__VITE_ASSET__C7N8P2uE__"